<template>
  <!-- 異動区分　2：改姓届 -->
  <div class="item">
    <b class="title required">(新)姓名</b>
    <input-text type="text" v-model="idou.todokede1_naiyou" :error="getError(idou, 'todokede1_naiyou')" placeholder="例）　管理　太郎"></input-text>
  </div>
  <div class="item">
    <b class="title">(新)姓名（カナ）</b>
    <input-text type="text" v-model="idou.todokede2_naiyou"  :error="getError(idou, 'todokede2_naiyou')" placeholder="例）　カンリ　タロウ"></input-text>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useForm } from "@/composable/form/form";
import { Idou } from '@/types/Shinsei';
export default defineComponent({
  props:{
    idou: {
      type: Object as () => Idou,
      default: null
    },
  },
  setup(props) {

    // エラー取得
    const { getError } = useForm();

    return {
      getError,
    };
  },
  components: {},
});
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>
